export const MAP_MIN_BLOCK_WIDTH_PERCENT = 0.8;
export const MAP_MIN_BLOCK_HEIGHT_PERCENT = 0.8;

export type SchedulePrintMapBlockPercents = {
  courtRowIndex: number;
  leftPercent: number;
  widthPercent: number;
  topPercent: number;
  heightPercent: number;
};

export function computeMapBlockPercents(
  startMs: number,
  endMs: number,
  dayStartMs: number,
  timelineMs: number,
  courtRowIndex: number,
  orientation: 'timeOnX' | 'timeOnY'
): SchedulePrintMapBlockPercents {
  const timeStartPercent = Math.max(0, ((startMs - dayStartMs) / timelineMs) * 100);
  const timeSpanPercent = Math.max(
    ((endMs - startMs) / timelineMs) * 100,
    orientation === 'timeOnX' ? MAP_MIN_BLOCK_WIDTH_PERCENT : MAP_MIN_BLOCK_HEIGHT_PERCENT
  );

  if (orientation === 'timeOnX') {
    return {
      courtRowIndex,
      leftPercent: timeStartPercent,
      widthPercent: timeSpanPercent,
      topPercent: 0,
      heightPercent: 100,
    };
  }

  return {
    courtRowIndex,
    leftPercent: 0,
    widthPercent: 100,
    topPercent: timeStartPercent,
    heightPercent: timeSpanPercent,
  };
}

export function buildMapAxisTicks(
  dayStartMs: number,
  dayEndMs: number,
  timeZone: string,
  getHhmmTimeString: (iso: string, tz: string) => string
): { label: string; leftPercent: number; topPercent: number }[] {
  const MS_PER_HOUR = 60 * 60 * 1000;
  const MS_PER_MINUTE = 60 * 1000;
  const timelineMs = Math.max(dayEndMs - dayStartMs, MS_PER_MINUTE);
  const ticks: { label: string; leftPercent: number; topPercent: number }[] = [];
  let tickMs = Math.ceil(dayStartMs / MS_PER_HOUR) * MS_PER_HOUR;
  while (tickMs <= dayEndMs) {
    const percent = ((tickMs - dayStartMs) / timelineMs) * 100;
    ticks.push({
      label: getHhmmTimeString(new Date(tickMs).toISOString(), timeZone),
      leftPercent: percent,
      topPercent: percent,
    });
    tickMs += MS_PER_HOUR;
  }
  return ticks;
}
